import { getLADClaimEmailStatusInProgress } from '@/redux/Claims/LossAndDamage/LossAndDamageClaimsActions';
import EmptyRecords from '@/views/components/Common/EmptyRecords';
import ScrollPagination from '@/views/components/Paginations/ScrollPagination';
import ContentSpinner from '@/views/components/Spinners/ContentSpinner';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LADEmailStatusCard from './LADEmailStatusCard';

const LADEmailStatus = ({ claimKey }) => {
  const dispatch = useDispatch();
  const { progressing, data } = useSelector((state) => state.lossAndDamage.claimEmailStatus);

  useEffect(() => {
    if (claimKey) {
      dispatch(getLADClaimEmailStatusInProgress({ claimKey }));
    }
  }, [claimKey]);

  return (
    <div className="h-100 overflow-hidden">
      {progressing ? (
        <ContentSpinner size="large" className="h-100" />
      ) : (
        <ScrollPagination className="h-100">
          {data?.length > 0 ? (
            data.map((item, index) => {
              // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
              return <LADEmailStatusCard key={index} data={item} />;
            })
          ) : (
            <EmptyRecords title="There is no email records found!" descriptionOne="" descriptionTwo="" />
          )}
        </ScrollPagination>
      )}
    </div>
  );
};

export default LADEmailStatus;
